/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X, Shield } from "lucide-react";
import { formatCurrency } from "../../utils/constants";

const WaivePenaltyModal = ({
  selectedPayment,
  showWaivePenaltyModal,
  setShowWaivePenaltyModal,
  handleWaivePenalty,
  penaltyNote,
  setPenaltyNote,
  error,
  setError,
}) => {
  return (
    showWaivePenaltyModal &&
    selectedPayment && (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
          <div className="p-6 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
            <h3 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
              <Shield size={18} /> Waive Penalty
            </h3>
            <button onClick={() => setShowWaivePenaltyModal(false)}>
              <X size={20} className="text-gray-400 dark:text-dark-muted" />
            </button>
          </div>
          <div className="p-6">
            <div className="space-y-4">
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Client
                </p>
                <p className="font-medium text-text dark:text-dark-text">
                  {selectedPayment.name}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Penalty Amount
                </p>
                <p className="font-medium  dark:text-dark-text text-orange-500">
                  {formatCurrency(selectedPayment.penaltyAmount)}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Reason for Waiving
                </p>
                <textarea
                  placeholder="Enter reason for waiving penalty..."
                  className="w-full px-4 py-2 rounded-xl bg-accent dark:bg-gray-900 border border-gray-200 dark:border-dark-border text-sm focus:outline-none focus:ring-2 focus:ring-primary text-text dark:text-dark-text resize-none h-24"
                  value={penaltyNote}
                  onChange={(e) => {
                    setPenaltyNote(e.target.value);
                    setError("");
                  }}
                />
                {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              </div>
              <button
                onClick={handleWaivePenalty}
                className="w-full py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-xl font-bold transition-colors"
              >
                Confirm Waive Penalty
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default WaivePenaltyModal;
